import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import DefaultError from "../../common/core-ui/DefaultError.tsx";
import styles from "./InsetHomeError.module.scss";
import { useEffect } from "react";
import { noticeError } from "../../common/api/monitoring/index.ts";

export default function InsetHomeError() {
  const error = useRouteError();
  const shouldThrowToRoot = isRouteErrorResponse(error);

  // Throw 404, etc up to root handler
  if (shouldThrowToRoot) {
    throw error;
  }

  useEffect(() => {
    if (shouldThrowToRoot) {
      // Don't duplicate root logging
      return;
    }

    if (error instanceof Error) {
      noticeError(error);
    } else {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }, [error, shouldThrowToRoot]);

  // Component error, show message inside frame
  return <DefaultError className={styles.error} />;
}
